<div class="modal-body">
  <h2 class="modal-title">Lägg till skogsvård på en yta</h2>

  <div class="hr-div">
    <hr>
    </div>

    <div class="pb-3">
      <rask-simple-selector
        class="w-100 skogsvard-select-kontrakt"
        label="Välj vilket kontrakt skogsvården ska hanteras på"
        [values]="selectKontraktForSkogsvardItems"
        [value]="preSelectedKontraktGuid"
        bindLabel="text"
        bindValue="value"
        [disabled]="true">
      </rask-simple-selector>
    </div>

    <div class="hr-div">
      <hr>
      </div>

      <div class="d-flex skogsvard-select-atgard-container">
        <div id="skogsvard-select-atgard" class="p-2 flex-fill">
          <rask-skogsvard-select-atgard
            [listOfAtgarder]="listOfAtgarder"
            [selectedAtgardGuid]="preSelectedAtgard"
            [isAtgardRequired]="false"
            [showCopyGeometries]="false"
            (selected)="skogsvardAtgardChanged($event)"></rask-skogsvard-select-atgard>
        </div>
      </div>

      @for (row of skogsvard.skogsvardRowTypes; track row; let i = $index) {
        <rask-skogsvard-create-row
          (deleted)="deleted($event)"
          [index]="i"
          [rowType]="row"
          [allSkogsvardGrupp]="skogsvardGrupper"
          [canDelete]="skogsvard.skogsvardRowTypes.length > 1"
          [isSkogsvardKontrakt]="false"
          (rowChanged)="rowChanged()">
        </rask-skogsvard-create-row>
      }

      <div class="d-flex add-skogsvard-row-container">
        <rask-action-button
          aid="buttonCreateSkogsvardRow"
          icon="far fa-plus"
        (click)="addSkogsvardRow()">Lägg till ytterligare skogsvård på vald yta</rask-action-button>
      </div>
      <div class="ms-2 pt-2">
        @if ((messages$ | async).length > 0) {
          <div>
            <rask-message-panel
              [numberOfItemsToDisplay]="1"
              [maxNumOfRows]="3"
              [items]="messages$">
            </rask-message-panel>
          </div>
        }
      </div>
      <div class="d-flex justify-content-end" id="skogsvard-create-end-row">
        <rask-button color="primary" [disabled]="!canSave()" (click)="save()">Skapa skogsvård</rask-button>
        <rask-button color="secondary" (click)="close()">Avbryt</rask-button>
      </div>
    </div>